import React from 'react';

// Mesmo footer da página inicial (PaginaInicial.js), sem o botão de
// "Acesso restrito" — esse é exclusivo da home, não faz sentido oferecer
// entrada de admin no meio do fluxo de uma enquete pública. Usado em todas
// as páginas de enquete (legadas e dinâmicas), que antes não tinham
// nenhum footer ou tinham versões parciais/inconsistentes entre si.
const FooterPublico = () => (
  <footer className="bg-gray-800 text-white py-8 mt-12">
    <div className="container-responsive text-center">
      <p className="text-gray-300 text-sm sm:text-base">
        © 2026 Prefeitura Municipal de Corumbá - Todos os direitos reservados
      </p>
      <p className="text-gray-400 text-xs sm:text-sm mt-2">
        Desenvolvido com ❤️ para a cidade de Corumbá-MS
      </p>
    </div>
  </footer>
);

export default FooterPublico;
